import { CHECKOUT_FORM_NAME } from '../constants';
import { ContactFields } from '../models/order';
import { CheckoutState } from '../state';
import { getFormValues } from './forms';
import { getNamespaceValue } from './utils/selector';

export const hasRequiredCannedQuestions = (state: CheckoutState) =>
    getNamespaceValue(
        state.expressCheckout,
        'expressCheckoutConditions.hasRequiredCannedQuestions',
        true,
    );

export const hasRequiredCustomQuestions = (state: CheckoutState) =>
    getNamespaceValue(
        state.expressCheckout,
        'expressCheckoutConditions.hasRequiredCustomQuestions',
        true,
    );

export const isApplePayAvailableAsPaymentMethod = (state: CheckoutState) =>
    getNamespaceValue(
        state.expressCheckout,
        'expressCheckoutConditions.hasApplePay',
        false,
    );

export const isContactInformationComplete = (state: CheckoutState) => {
    const { buyer } = getFormValues(state, CHECKOUT_FORM_NAME) || {};

    return (
        buyer?.[ContactFields.EMAIL] &&
        buyer?.[ContactFields.FIRST_NAME] &&
        buyer?.[ContactFields.LAST_NAME]
    );
};

export const hasQuestions = (state: CheckoutState) =>
    hasRequiredCannedQuestions(state) || hasRequiredCustomQuestions(state);

// TODO: Pending to get the proper value when EB-211005 has been done
export const isPaypalEPPAvailable = (_state: CheckoutState) => false;
